export const socialDefaults = Object.freeze({
  facebook: "https://www.facebook.com/ppnckh",
  youtube: "https://www.youtube.com/@vietlod",
  zalo: "https://zalo.me/0916337992",
  hotline: "tel:+84916337992",
  website: "https://www.tnsai.vn",
});
